import InvestorDashBanner from './investor-dash-banner';

export default InvestorDashBanner;
